module.exports = __webpack_public_path__ + "img/KSC04224.1df34da8.jpg";